import { css, cx } from 'linaria';
import TopicsPillbox from 'components/topics-pillbox/topics-pillbox';
import { breakpointLargeTablet } from '@pocket/web-ui';
import { breakpointTinyTablet } from '@pocket/web-ui';
const topicsNavRightRailStyle = "t1lxy6gw";
const topicsNavBottomStyle = "t15nvgb";
const topicsNavBottomHeadingStyle = "t1vb1gsz";
export function CardTopicsNav({
  topics,
  rail,
  track,
  className
}) {
  const moduleClass = rail ? topicsNavRightRailStyle : topicsNavBottomStyle;
  const headingClass = rail ? 'h6' : topicsNavBottomHeadingStyle;
  return <div className={cx('cardTopicsNav', moduleClass, className)}>
      <div className="inner">
        <TopicsPillbox id={rail ? 'right-rail-topics' : 'page-bottom-topics'} topicsMap={topics} headingText="Discover More Topics" headingClassName={headingClass} onTopicClick={track} />
      </div>
    </div>;
}

require("../../../.linaria-cache/src/connectors/topic-list/topic-list.linaria.module.css");